import Competences from './Competences.vue';

export default Competences;



// WEBPACK FOOTER //
// ./src/pages/competences/list/index.ts